import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getWorkOrder, updateWorkOrder, deleteWorkOrder } from "../../../components/http";
import WorkOrderInfoEdit from "./WorkOrderInfoEdit";
import style from "./EditWorkOrder.module.scss";
import ClientCars from "../../clients/client/[client_id]/ClientCars";
import ClientInfo from "../../cars/[car_id]/ClientInfo";
import HeaderInfo from "../../../components/header/headerInfo";
import ConfirmationModal from "../../../components/PopUps/ConfirmDeleteButton";
import { useTranslation } from "react-i18next";

const WorkOrderDetails = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(); 
  const { work_order_id } = useParams();
  const [workOrder, setWorkOrder] = useState(null);
  const [initialWorkOrder, setInitialWorkOrder] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    const fetchWorkOrder = async () => {
      try {
        if (!work_order_id) return;
        const fetchedOrder = await getWorkOrder(work_order_id);
        if (fetchedOrder) {
          setWorkOrder(fetchedOrder);
          setInitialWorkOrder(fetchedOrder);
        }
      } catch (error) {
        console.error(t("workOrder.details.errors.fetching"), error);
      }
    };

    fetchWorkOrder();
  }, [work_order_id, t]);

  const handleEditClick = () => setIsEditing(!isEditing);

  const handleSave = async () => {
    if (!workOrder || !initialWorkOrder) return;

    try {
      const changedFields = {};
      Object.keys(workOrder).forEach((key) => {
        if (workOrder[key] !== initialWorkOrder[key]) {
          changedFields[key] = workOrder[key];
        }
      });

      if (Object.keys(changedFields).length === 0) {
        alert(t("workOrder.details.alerts.noChanges"));
        return;
      }

      await updateWorkOrder({ work_order_id: workOrder.id, values: changedFields });
      setIsEditing(false);
      alert(t("workOrder.details.alerts.success"));
    } catch (error) {
      console.error(t("workOrder.details.errors.updating"), error);
      alert(t("workOrder.details.alerts.errorSaving"));
    }
  };

  const handleDeleteWorkOrder = async (id) => {
    await ConfirmationModal({
      title: t("workOrder.popUp.delete"),
      text: t("workOrder.popUp.deleteConfirm"),
      confirmButtonColor: "#d33",
      confirmButtonText: t("workOrder.popUp.confirmButtonText"),
      cancelButtonText: t("workOrder.popUp.cancelButtonText"),
      cancelButtonColor: "#3085d6",
      onConfirm: async () => {
        try {
          await deleteWorkOrder(id);
          navigate(-1);
        } catch (error) {
          console.error(t("workOrder.details.errors.deleting"), error);
        }
      },
      successTitle: t("workOrder.popUp.deleted"),
      successText: t("workOrder.popUp.deleteSuccess"),
    });
  };

  if (!workOrder) return <div>{t("loading")}</div>;

  return (
    <div className={style.orderContainer}>
      <HeaderInfo onEditClick={handleEditClick} onDelete={() => handleDeleteWorkOrder(workOrder.id)} />
      <div className={style.container}>
        <WorkOrderInfoEdit workOrder={workOrder} isEditing={isEditing} onWorkOrderChange={setWorkOrder} />
        <div className={style.containerInfo}>
          <ClientInfo car={workOrder} isEditing={isEditing} />
          <ClientCars cars={workOrder.car} isEditing={isEditing} />
        </div>
      </div>
      
      {isEditing && (
        <button className={style.saveButton} onClick={handleSave}>
          {t("workOrder.details.saveChanges")}
        </button>
      )}
    </div>
  );
};

export default WorkOrderDetails;
